// extracted by mini-css-extract-plugin
export default {"label":"LanguageSelector_label__V+Zzg","down":"LanguageSelector_down__-8Z4e"};